import { createNS } from '@ontologies/core';

const fa4 = createNS('http://fontawesome.io/icon/');

export default {
  ns: fa4,
};
